/* MelodyGlow Sprachpaket "fr" – generiert aus MG-i18n/packs/fr/js.json mit theme/js-tests/build-pack.mjs. Nicht von Hand ändern.
   Wird vom Layout nur für diese Sprache vor melodyglow.js geladen; melodyglow.js liest es mit try/catch, fehlende Texte → Englisch. */
window.MG_PACK = {
 "locale": "fr",
 "intl": "fr-FR",
 "strings": {
  "Audio sample": "Extrait audio",
  "Die Hörprobe konnte nicht abgespielt werden. Tippe auf Play, um es erneut zu versuchen.": "L’extrait n’a pas pu être lu. Appuyez sur lecture pour réessayer.",
  " — erneut versuchen": " — réessayer",
  "heute": "aujourd’hui",
  "morgen": "demain",
  "{day}, {time} Uhr": "{day} à {time}",
  "MELODYGLOW ANGEBOT": "OFFRE MELODYGLOW",
  "auf deinen persönlichen Song": "sur votre chanson personnalisée",
  " Rabatt": " de réduction",
  "Dein": "Votre",
  "eigene Richtung": "votre propre style",
  "passend zu eurer Geschichte": "selon votre histoire",
  "Frauenstimme": "voix féminine",
  "Männerstimme": "voix masculine",
  "Duett": "en duo",
  "passend zum Song": "selon la chanson",
  "Deine Antworten werden sortiert": "Nous rassemblons vos réponses",
  "Musikstil: ": "Style musical\u00a0: ",
  "Stimme: ": "Voix\u00a0: ",
  "Erste Zeilen für {name} entstehen": "Les premiers vers pour {name} prennent forme",
  "Erste Zeilen entstehen": "Les premiers vers prennent forme",
  "Melodie wird vorbereitet": "Préparation de la mélodie",
  "Die erste Minute deines Songs. Nach der Bestellung bekommst du ihn in voller Länge – mit deinem Änderungswunsch.": "La première minute de votre chanson. Après votre commande, vous la recevez en version intégrale – avec votre demande de modification.",
  "Die erste Minute deines Songs. Nach der Bestellung bekommst du genau diesen Song in voller Länge.": "La première minute de votre chanson. Après votre commande, vous recevez cette même chanson en version intégrale.",
  "Möchtest du am finalen Song etwas ändern?": "Vous souhaitez modifier quelque chose dans la version finale\u00a0?",
  "Hast du noch einen besonderen Wunsch für deinen Song?": "Une demande particulière pour votre chanson\u00a0?",
  "Dein Änderungswunsch für den finalen Song": "Votre demande de modification pour la version finale",
  "Dein Wunsch für deinen Song": "Votre demande particulière",
  "Wir setzen ihn nach deiner Bestellung im finalen Song um. Bei kleinen Änderungen bleibt die Melodie, die du gerade hörst.": "Nous l’intégrerons à la version finale après votre commande. Pour de petites modifications, la mélodie que vous écoutez reste la même.",
  "Wir berücksichtigen ihn nach deiner Bestellung in deinem Song.": "Nous en tiendrons compte dans votre chanson après votre commande.",
  "Bitte beschreibe deinen Wunsch etwas genauer.": "Veuillez préciser un peu votre demande.",
  "Wird gespeichert …": "Enregistrement…",
  "Dein Song ist schon in Produktion. Änderungen kannst du danach direkt auf deiner Songseite anfragen.": "Votre chanson est déjà en production. Vous pourrez ensuite demander des modifications directement sur la page de votre chanson.",
  "Bitte fasse deinen Wunsch etwas kürzer (höchstens 1000 Zeichen).": "Veuillez raccourcir un peu votre demande (1\u202f000 caractères maximum).",
  "Das Speichern hat gerade nicht geklappt. Bitte versuche es noch einmal.": "L’enregistrement n’a pas fonctionné. Veuillez réessayer.",
  "Gleich geschafft – letzter Feinschliff …": "Presque terminé – dernières retouches…",
  "Melodie und Gesang entstehen …": "Création de la mélodie et du chant…",
  "Der Songtext für {name} wird geschrieben …": "Les paroles pour {name} sont en cours d’écriture…",
  "Dein Songtext wird geschrieben …": "Vos paroles sont en cours d’écriture…",
  "Dauert heute etwas länger – noch einen Moment …": "Cela prend un peu plus de temps aujourd’hui – encore un instant…",
  "Deine Hörprobe braucht heute länger als sonst. Wir schicken dir den Link per E-Mail, sobald sie fertig ist. Deine Angaben sind gespeichert – du kannst trotzdem schon bestellen.": "Votre extrait prend plus de temps que d’habitude aujourd’hui. Nous vous enverrons le lien par e-mail dès qu’il sera prêt. Vos informations sont enregistrées – vous pouvez déjà commander.",
  "Deine Hörprobe braucht heute länger als sonst. Sie erscheint hier automatisch, sobald sie fertig ist. Deine Angaben sind gespeichert – du kannst trotzdem schon bestellen.": "Votre extrait prend plus de temps que d’habitude aujourd’hui. Il s’affichera ici automatiquement dès qu’il sera prêt. Vos informations sont enregistrées – vous pouvez déjà commander.",
  "Deine Hörprobe lädt noch kurz – sie erscheint hier oben automatisch.": "Votre extrait est encore en cours de chargement – il s’affichera ici automatiquement.",
  "Deine Hörprobe ist fertig – hier oben anhören.": "Votre extrait est prêt – écoutez-le ci-dessus.",
  "Deine Hörprobe entsteht": "Votre extrait est en cours de création",
  "Deine persönliche Hörprobe": "Votre extrait personnalisé",
  "Dein persönlicher Song": "Votre chanson personnalisée",
  "{who} Song entsteht gerade.": "La chanson {who} est en cours de création.",
  "Dein Song entsteht gerade.": "Votre chanson est en cours de création.",
  "Das ist {who} Song.": "Voici la chanson {who}.",
  "Das ist dein Song.": "Voici votre chanson.",
  "Dein persönlicher Song für {name}.": "Votre chanson personnalisée pour {name}.",
  "Dein persönlicher Song.": "Votre chanson personnalisée.",
  "„{title}“": "«\u00a0{title}\u00a0»",
  "Ein Song für ": "Une chanson pour ",
  "deinen Herzensmenschen": "la personne qui vous est chère",
  "Song für {name} sichern": "Obtenir la chanson {who}",
  "Deinen Song sichern": "Obtenir votre chanson",
  "So klingt dein gewählter Musikstil:": "Voici le style musical que vous avez choisi\u00a0:",
  "Ein Hörbeispiel aus unserem Angebot:": "Un exemple tiré de notre répertoire\u00a0:",
  "Deine Hörprobe ist gerade nicht verfügbar. Deine Angaben sind gespeichert – du kannst trotzdem bestellen.": "Votre extrait n’est pas disponible pour le moment. Vos informations sont enregistrées – vous pouvez quand même commander.",
  "Deine Hörprobe konnte diesmal leider nicht erstellt werden. Deine Angaben sind gespeichert – du kannst trotzdem bestellen, dein Song wird wie gewohnt in voller Länge für dich produziert.": "Votre extrait n’a malheureusement pas pu être créé cette fois-ci. Vos informations sont enregistrées – vous pouvez quand même commander\u00a0: votre chanson sera produite en version intégrale, comme d’habitude.",
  "Deine Hörprobe braucht gerade länger als gewohnt. Deine Angaben sind gespeichert – du kannst trotzdem schon bestellen.": "Votre extrait prend plus de temps que d’habitude. Vos informations sont enregistrées – vous pouvez déjà commander.",
  " Über den Link in unserer E-Mail kannst du sie später anhören.": " Vous pourrez l’écouter plus tard grâce au lien reçu par e-mail.",
  "♪ Deine Hörprobe ist fertig": "♪ Votre extrait est prêt",
  "Anhören": "Écouter",
  "Songtext für {name} wird geschrieben": "Écriture des paroles pour {name}",
  "Dein Songtext wird geschrieben": "Écriture de vos paroles",
  "Fertig!": "Terminé\u00a0!",
  "{who} Song ist fertig.": "La chanson {who} est prête.",
  "Dein Song ist fertig.": "Votre chanson est prête.",
  "Hörprobe abspielen": "Écouter l’extrait",
  "Hörprobe pausieren": "Mettre l’extrait en pause",
  "Weiter zur Hörprobe →": "Continuer vers l’extrait\u00a0→",
  "Weiter →": "Suivant\u00a0→",
  "Weitere Person ": "Autre personne ",
  "Name der weiteren Person ": "Prénom de l’autre personne ",
  "Person {n} entfernen": "Retirer la personne {n}",
  "{count} von maximal {max} ausgewählt": "{count} choix sur {max} maximum",
  "diesen Menschen": "cette personne",
  "Jetzt fehlen die Momente, die nur ihr kennt": "Place aux moments que personne d’autre ne connaît",
  "Was ist typisch für ": "Qu’est-ce qui caractérise ",
  "Was soll ": "Que doit savoir ",
  " nach dem letzten Ton wissen?": " après la dernière note\u00a0?",
  "Für ": "Pour ",
  "Ohne weitere Details weiter →": "Continuer sans plus de détails\u00a0→",
  "Tipp: Schon 2–3 Stichpunkte machen den Song deutlich persönlicher.": "Astuce\u00a0: 2 ou 3 mots-clés suffisent à rendre la chanson bien plus personnelle.",
  "Guter Anfang! Ein konkretes Detail – ein Ort, ein Insider, ein Satz – macht den Unterschied.": "Bon début\u00a0! Un détail concret – un lieu, une blague entre vous, une phrase – fait toute la différence.",
  "Sehr schön – noch eine Erinnerung, und der Song wird unverwechselbar.": "Très bien – encore un souvenir, et la chanson sera unique.",
  "Perfekt – daraus lässt sich ein sehr persönlicher Song schreiben.": "Parfait – de quoi écrire une chanson très personnelle.",
  "Wie heißt {who}?": "Comment s’appelle {who}\u00a0?",
  "Wie heißt dein Herzensmensch?": "Quel est son prénom\u00a0?",
  "Was soll in {who} Song vorkommen?": "Que doit raconter la chanson {who}\u00a0?",
  "Was soll im Song vorkommen?": "Que doit raconter la chanson\u00a0?",
  "Wir bereiten {who} Song vor …": "Nous préparons la chanson {who}…",
  "Wir bereiten deinen Song vor …": "Nous préparons votre chanson…",
  "{who} Song kann starten.": "Tout est prêt pour la chanson {who}.",
  "Dein Song kann starten.": "Tout est prêt pour votre chanson.",
  "deine besondere Person": "la personne qui vous est chère",
  "euer Moment": "votre moment",
  "Stilbeispiel (nicht dein Song): ": "Exemple de style (pas votre chanson)\u00a0: ",
  "Ein Beispiel aus unserem Angebot (nicht dein Song)": "Un exemple de notre répertoire (pas votre chanson)",
  "E-Mail aus deinem gespeicherten Songprofil": "Adresse e-mail déjà enregistrée",
  "du": "toi",
  "Was macht diesen Menschen besonders – und was möchtest du zu Weihnachten sagen? Stichpunkte reichen.": "Qu’est-ce qui rend cette personne unique – et que voulez-vous lui dire pour Noël\u00a0? Quelques mots-clés suffisent.",
  "Eine gemeinsame Erinnerung, ein typischer Satz, das, was du sagen möchtest. Stichpunkte reichen.": "Un souvenir commun, son expression fétiche, ce que vous voulez lui dire. Quelques mots-clés suffisent.",
  "Person": "Destinataire",
  "Schritt {n} von {total}": "Étape {n} sur {total}",
  "Bitte wähle aus, für wen der Song ist.": "Veuillez indiquer à qui s’adresse la chanson.",
  "Für wen ist der Song genau? Ein Wort reicht, z. B. Schwiegermutter.": "Pour qui est la chanson, exactement\u00a0? Un mot suffit, par ex. belle-mère.",
  "Bitte wähle einen Anlass.": "Veuillez choisir une occasion.",
  "Welcher Anlass ist es? Ein Stichwort reicht.": "De quelle occasion s’agit-il\u00a0? Un mot suffit.",
  "Bitte gib einen Namen ein – so, wie er im Song vorkommen soll.": "Veuillez indiquer un prénom – tel qu’il doit être chanté.",
  "Welcher Stil soll es sein? Ein Stichwort reicht, z. B. Bossa Nova.": "Quel style souhaitez-vous\u00a0? Un mot suffit, par ex. bossa-nova.",
  "Bitte wähle die Sprache des Songs.": "Veuillez choisir la langue de la chanson.",
  "Welche Sprache soll es sein?": "Quelle langue souhaitez-vous\u00a0?",
  "Bitte füge deinen Songtext ein – oder schreib doch lieber Stichpunkte.": "Veuillez coller vos paroles – ou notez plutôt quelques mots-clés.",
  "Schon ein, zwei Stichpunkte – ein Insider, ein Ort oder ein typischer Satz von euch – machen den Song deutlich persönlicher. Du kannst aber auch direkt weitergehen.": "Un ou deux mots-clés – une blague entre vous, un lieu ou une phrase bien à vous – rendent la chanson bien plus personnelle. Vous pouvez aussi continuer directement.",
  "Dein Briefing ist bereits gespeichert. Bitte schließe jetzt nur noch das Hinzufügen zum Warenkorb ab.": "Vos réponses sont déjà enregistrées. Il ne reste plus qu’à ajouter la chanson au panier.",
  "Person & Anlass": "Personne et occasion",
  "Beschenkte Person: ": "Destinataire\u00a0: ",
  "Noch kein Name": "Pas encore de prénom",
  "Beziehung: ": "Relation\u00a0: ",
  "Absender: ": "De la part de\u00a0: ",
  "Aussprache: ": "Prononciation\u00a0: ",
  "Anlass: ": "Occasion\u00a0: ",
  "Verbindung: ": "Lien\u00a0: ",
  "Weitere Personen: ": "Autres personnes\u00a0: ",
  "Klang & Stimme": "Style et voix",
  "Musikrichtung: ": "Style musical\u00a0: ",
  "Stimmung: ": "Ambiance\u00a0: ",
  "Perspektive: ": "Point de vue\u00a0: ",
  "Sprache: ": "Langue\u00a0: ",
  "Musikalische Referenz: ": "Référence musicale\u00a0: ",
  "Eure Geschichte": "Votre histoire",
  "Der Anfang: ": "Les débuts\u00a0: ",
  "Wichtige Momente: ": "Moments importants\u00a0: ",
  "Eigenschaften: ": "Traits de caractère\u00a0: ",
  "Botschaft & Hinweise": "Message et remarques",
  "Kernbotschaft: ": "Message principal\u00a0: ",
  "Unbedingt erwähnen: ": "À mentionner absolument\u00a0: ",
  "Nicht erwähnen: ": "À ne pas mentionner\u00a0: ",
  "Weitere Hinweise: ": "Autres remarques\u00a0: ",
  "{count} Schritte vorbereitet": {
   "one": "{count} étape préparée",
   "other": "{count} étapes préparées"
  },
  "Keine Angabe": "Non précisé",
  "Mit Express voraussichtlich per E-Mail bis": "Avec l’express, livraison par e-mail prévue pour",
  "Voraussichtlich per E-Mail bis": "Livraison par e-mail prévue pour",
  "({count} gewählt)": {
   "one": "({count} option)",
   "other": "({count} options)"
  },
  "Der Preis konnte nicht geladen werden. Bitte lade die Seite erneut.": "Impossible de charger le prix. Veuillez recharger la page.",
  "Bitte prüfe deine E-Mail-Adresse.": "Veuillez vérifier votre adresse e-mail.",
  "Kurze Sicherheitsprüfung …": "Petite vérification de sécurité…",
  "Die Sicherheitsprüfung hat gerade nicht geklappt. Tippe bitte noch einmal auf den Button. Klappt es wieder nicht, deaktiviere kurz deinen Werbeblocker oder öffne die Seite in einem anderen Browser – deine Angaben bleiben gespeichert.": "La vérification de sécurité n’a pas abouti. Veuillez appuyer à nouveau sur le bouton. Si cela échoue encore, désactivez brièvement votre bloqueur de publicités ou ouvrez la page dans un autre navigateur – vos réponses restent enregistrées.",
  "Bitte schließe zuerst die Sicherheitsprüfung ab.": "Veuillez d’abord effectuer la vérification de sécurité.",
  "Der Cloudflare Intake-Endpunkt ist im Theme-Editor noch nicht als HTTPS-URL hinterlegt.": "Le point d’entrée Cloudflare n’est pas encore configuré en URL HTTPS dans l’éditeur de thème.",
  "Bitte verknüpfe im Theme-Editor ein Song-Produkt oder trage eine gültige Variant-ID ein.": "Associez un produit chanson dans l’éditeur de thème ou indiquez un ID de variante valide.",
  "Warenkorb wird vorbereitet …": "Préparation de votre panier…",
  "Deine Hörprobe wird geöffnet …": "Ouverture de votre extrait…",
  "Dein Briefing ist gespeichert, aber die gewählte Produktvariante ist gerade nicht verfügbar. Du kannst den Warenkorb-Schritt erneut versuchen oder diesen Versuch verwerfen und neu beginnen.": "Vos réponses sont enregistrées, mais la variante choisie n’est pas disponible pour le moment. Vous pouvez réessayer l’ajout au panier ou abandonner cette tentative et recommencer.",
  "Dein Briefing ist gespeichert, aber der Warenkorb war kurz nicht erreichbar. Deine Angaben sind jetzt gesperrt; bitte klicke erneut, um nur den Warenkorb-Schritt zu wiederholen.": "Vos réponses sont enregistrées, mais le panier était momentanément inaccessible. Vos informations sont maintenant verrouillées\u00a0; cliquez à nouveau pour ne répéter que l’étape du panier.",
  "Der Warenkorb wird möglicherweise noch verarbeitet. Bitte warte kurz und klicke erneut; vor einem weiteren Hinzufügen prüfen wir zuerst die vorhandene Konfigurations-ID.": "Le panier est peut-être encore en cours de traitement. Patientez un instant, puis cliquez à nouveau\u00a0; avant tout nouvel ajout, nous vérifions d’abord l’identifiant de configuration existant.",
  "Diese Konfigurations-ID liegt bereits mit einer anderen Produktvariante im Warenkorb. Bitte entferne diese Position im Warenkorb und versuche es danach erneut.": "Cet identifiant de configuration figure déjà dans le panier avec une autre variante. Retirez cet article du panier, puis réessayez.",
  "Die Sicherheitsprüfung ist abgelaufen. Bitte bestätige sie erneut und versuche es noch einmal.": "La vérification de sécurité a expiré. Veuillez la valider à nouveau, puis réessayer.",
  "Deine Antworten haben sich nach einem früheren Speicherversuch geändert. Wir haben eine neue technische Anfrage vorbereitet; bitte bestätige die Sicherheitsprüfung erneut und klicke noch einmal.": "Vos réponses ont changé depuis une précédente tentative d’enregistrement. Nous avons préparé une nouvelle demande\u00a0; veuillez valider à nouveau la vérification de sécurité et cliquer encore une fois.",
  "Deine Antworten sind noch da. Die Verbindung hat gerade nicht mitgespielt – bitte versuche es erneut.": "Vos réponses sont toujours là. La connexion n’a pas fonctionné – veuillez réessayer.",
  "Zur Kasse →": "Passer commande\u00a0→",
  "Weiter zur sicheren Kasse →": "Commander en toute sécurité\u00a0→",
  "Meintest du ": "Vouliez-vous dire ",
  "?": "\u00a0?",
  "dir": "cette personne",
  "Songreise starten →": "Créer votre chanson\u00a0→",
  "Der Warenkorb wird möglicherweise noch verarbeitet. Bitte warte kurz und versuche das Ändern danach erneut.": "Le panier est peut-être encore en cours de traitement. Patientez un instant, puis réessayez la modification.",
  "Der Warenkorb konnte nicht sicher geprüft werden. Bitte versuche es später erneut; deine Angaben bleiben erhalten.": "Le panier n’a pas pu être vérifié de façon fiable. Veuillez réessayer plus tard\u00a0; vos informations sont conservées.",
  "Der Warenkorb wird möglicherweise noch verarbeitet. Bitte warte insgesamt 60 Sekunden ab; danach prüfen und entfernen wir die Position vor einem Neustart.": "Le panier est peut-être encore en cours de traitement. Veuillez patienter 60 secondes au total\u00a0; nous vérifierons et retirerons ensuite l’article avant de recommencer.",
  "Alle Angaben löschen und einen neuen Song beginnen?": "Effacer toutes les informations et commencer une nouvelle chanson\u00a0?",
  "Der Warenkorb konnte nicht sicher geprüft und bereinigt werden. Bitte versuche es später erneut; dein gespeichertes Briefing bleibt bis dahin gesperrt.": "Le panier n’a pas pu être vérifié et vidé de façon fiable. Veuillez réessayer plus tard\u00a0; d’ici là, vos réponses enregistrées restent verrouillées.",
  "Gespeichertes Briefing zum Warenkorb hinzufügen →": "Ajouter vos réponses au panier\u00a0→",
  "Entwurf fortsetzen →": "Reprendre votre chanson\u00a0→",
  "Dieses Angebot wurde bereits bestellt. Bitte prüfe deine Bestellbestätigung.": "Cette offre a déjà été commandée. Veuillez consulter votre confirmation de commande.",
  "Dieser Angebotslink ist abgelaufen oder konnte nicht geladen werden. Du kannst hier einen neuen Song beginnen.": "Ce lien d’offre a expiré ou n’a pas pu être chargé. Vous pouvez commencer une nouvelle chanson ici.",
  " Tage ": " j ",
  "Songpaket wählen": "Choisir une formule",
  "nur + {price} zum Song": "seulement {price} de plus que la chanson",
  "+ {price} zum Geschenk-Set": "{price} de plus que le coffret cadeau",
  "✓ Ausgewählt": "✓ Votre choix",
  "Paket wählen": "Choisir",
  "Individuelle Auswahl": "Sélection personnalisée",
  "Deine Auswahl: ": "Votre sélection\u00a0: ",
  "Persönlicher Song": "Chanson personnalisée",
  "E-Mail-Guthaben": "Crédit reçu par e-mail",
  "inklusive": "incluse",
  "Paketpreise · 2h-Express bei jedem Paket zubuchbar": "Prix des formules · livraison express (2\u00a0h) en option",
  "Geschenk-Set: Aufsteller + Songtext-PDF": "Coffret cadeau\u00a0: plaque acrylique + paroles en PDF",
  "Der 2h-Express ist gerade nicht im Paket „Komplett“ enthalten. Wir haben ihn aus deiner Auswahl genommen – bitte prüfe den Gesamtpreis und geh dann erneut zur Kasse.": "La livraison express (2\u00a0h) n’est pas incluse dans le pack complet pour le moment. Nous l’avons retirée de votre sélection\u00a0: vérifiez le total, puis passez à nouveau commande.",
  "Der Set-Preis für das Geschenk-Set kann gerade nicht angewendet werden. Aufsteller und Songtext-PDF bleiben zum Einzelpreis in deiner Auswahl, du kannst sie wieder abwählen. Bitte prüfe den Gesamtpreis und geh dann erneut zur Kasse.": "Le prix du coffret cadeau ne peut pas être appliqué pour le moment. La plaque acrylique et les paroles en PDF restent dans votre sélection au prix affiché\u00a0; vous pouvez les retirer. Vérifiez le total, puis passez à nouveau commande."
 },
 "labels": {
  "Weniger als ein Jahr": "Moins d’un an",
  "1–3 Jahre": "1 à 3 ans",
  "4–7 Jahre": "4 à 7 ans",
  "8–15 Jahre": "8 à 15 ans",
  "Mehr als 15 Jahre": "Plus de 15 ans",
  "Etwas anderes": "Autre chose",
  "Baby oder Kleinkind": "Bébé ou tout-petit",
  "Schulkind": "Enfant d’âge scolaire",
  "Teenager": "Adolescent(e)",
  "Erwachsen": "Adulte",
  "Eng und vertraut": "Proches et complices",
  "Voller Dankbarkeit": "Une profonde gratitude",
  "Viele gemeinsame Jahre": "De nombreuses années ensemble",
  "Wir haben wieder zueinandergefunden": "Nous nous sommes retrouvés",
  "Seit der Kindheit verbunden": "Liés depuis l’enfance",
  "Durch Höhen und Tiefen": "À travers les hauts et les bas",
  "Viele Abenteuer erlebt": "Beaucoup d’aventures partagées",
  "Derselbe Humor": "Le même sens de l’humour",
  "Familie im Herzen": "Une famille de cœur",
  "Durch einen besonderen Moment verbunden": "Liés par un moment unique",
  "Schon viele Jahre": "Depuis de nombreuses années",
  "Ganz neu in meinem Leben": "Une rencontre récente",
  "Weihnachten": "Noël",
  "Geburtstag": "Anniversaire",
  "Hochzeit oder Jahrestag": "Mariage ou anniversaire de couple",
  "Heiratsantrag": "Demande en mariage",
  "Geburt oder Taufe": "Naissance ou baptême",
  "Danke sagen": "Dire merci",
  "Mut machen oder Trost schenken": "Encourager ou réconforter",
  "Einfach so": "Juste comme ça",
  "Ein anderer Anlass": "Une autre occasion",
  "Pop": "Pop",
  "Ballade": "Ballade au piano",
  "House / Dance": "Dance / Électro",
  "Schlager": "Variété allemande",
  "R&B / Soul": "R&B / Soul",
  "Country / Folk": "Folk / Country",
  "Akustik": "Acoustique",
  "Andere Musikrichtung": "Un autre style",
  "Ihr dürft entscheiden": "Laissez-nous choisir",
  "Gefühlvoller Deutschpop": "Pop allemande émouvante",
  "Piano-Ballade": "Ballade au piano",
  "Moderner Schlager": "Variété allemande moderne",
  "Rock": "Rock",
  "Rap": "Rap / Hip-hop",
  "Überrascht mich": "Surprenez-moi",
  "Tief berührend": "Profondément émouvante",
  "Fröhlich": "Joyeuse",
  "Warm & geborgen": "Chaleureuse et rassurante",
  "Romantisch": "Romantique",
  "Nostalgisch": "Nostalgique",
  "Leicht & verspielt": "Légère et espiègle",
  "Kraftvoll": "Puissante",
  "Ruhig": "Calme",
  "Hoffnungsvoll": "Pleine d’espoir",
  "Weibliche Stimme": "Voix féminine",
  "Männliche Stimme": "Voix masculine",
  "Beide Stimmen": "En duo",
  "Direkt mit du": "En tutoyant directement la personne",
  "Über die Person erzählt": "En parlant de la personne",
  "Aus unserer wir-Perspektive": "De notre point de vue («\u00a0nous\u00a0»)",
  "Deutsch": "Allemand",
  "Englisch": "Anglais",
  "Deutsch & Englisch gemischt": "Allemand et anglais mélangés",
  "Andere Sprache": "Une autre langue",
  "Herzlich": "Au grand cœur",
  "Humorvoll": "Drôle",
  "Mutig": "Intrépide",
  "Verlässlich": "Fiable",
  "Lebensfroh": "Solaire",
  "Kreativ": "Artiste dans l’âme",
  "Für andere da": "Toujours là pour les autres",
  "Ein bisschen chaotisch": "Un brin chaotique",
  "Etwas Eigenes": "Autre chose",
  "Französisch": "Français",
  "Indie / Alternative": "Indie / Alternative"
 },
 "picks": {
  "recipient": {
   "partner-m": {
    "label": "Mari ou compagnon",
    "who": "votre partenaire"
   },
   "partner-f": {
    "label": "Femme ou compagne",
    "who": "votre partenaire"
   },
   "mama": {
    "label": "Maman",
    "who": "votre maman"
   },
   "papa": {
    "label": "Papa",
    "who": "votre papa"
   },
   "tochter": {
    "label": "Fille",
    "who": "votre fille"
   },
   "sohn": {
    "label": "Fils",
    "who": "votre fils"
   },
   "enkel": {
    "label": "Petit-enfant",
    "who": "votre petit-enfant"
   },
   "freundin": {
    "label": "Amie",
    "who": "votre amie"
   },
   "freund": {
    "label": "Ami",
    "who": "votre ami"
   },
   "schwester": {
    "label": "Sœur",
    "who": "votre sœur"
   },
   "bruder": {
    "label": "Frère",
    "who": "votre frère"
   },
   "oma": {
    "label": "Mamie",
    "who": "votre mamie"
   },
   "opa": {
    "label": "Papi",
    "who": "votre papi"
   },
   "other": {
    "label": "",
    "who": "la personne"
   }
  },
  "occasion": {
   "jahrestag": "Anniversaire de couple",
   "hochzeit": "Mariage",
   "liebe": "Déclaration d’amour",
   "erinnerung": "En mémoire d’un être cher",
   "ruhestand": "Départ à la retraite"
  }
 },
 "roles": {
  "partner": "Partenaire",
  "child": "Fille / fils",
  "parent": "Mère / père",
  "sibling": "Sœur / frère",
  "friend": "Amie / ami",
  "grandparents": "Grands-parents",
  "other": "Une autre personne chère"
 },
 "format": {
  "time": "{H}\u00a0h\u00a0{mm}",
  "thousands": "\u202f"
 },
 "grammar": {
  "possessive": [
   [
    "^(?:[aeiouàâäæéèêëîïôöœùûüh]|y(?![aeiouàâäéèêëîïôöùûü]))",
    "d’{name}"
   ],
   [
    "",
    "de {name}"
   ]
  ]
 },
 "emailDomains": [
  "orange.fr",
  "wanadoo.fr",
  "free.fr",
  "sfr.fr",
  "neuf.fr",
  "laposte.net",
  "hotmail.fr",
  "live.fr",
  "outlook.fr",
  "yahoo.fr",
  "gmx.fr",
  "bbox.fr",
  "club-internet.fr",
  "aliceadsl.fr",
  "numericable.fr",
  "msn.com",
  "protonmail.com",
  "proton.me",
  "skynet.be",
  "telenet.be",
  "hotmail.be",
  "yahoo.be",
  "voo.be",
  "pt.lu"
 ]
};
